import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors, ExpandMoreIcon } from "@dotnet/telematics-design-system";

import { useMenu } from "components/Actions/ActionBar/hooks/useMenu";
import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import ListChoice from "components/DesignComponents/ListChoice";
import Menu from "components/DesignComponents/Menu";
import { body3SemiBoldStyles } from "shared/styles/typography";

import { PeriodSettingsProps } from "./types";

const PeriodSettings = ({ period, onChange }: PeriodSettingsProps) => {
    const { gray700 } = colors;

    const { t } = useTranslation();
    const { anchorEl, handleOpenMenu, handleCloseMenu } = useMenu();

    const periods = [1, 7, 30, 90];

    return (
        <div
            css={css({
                display: "flex",
                alignItems: "center",

                "& > span": {
                    ...body3SemiBoldStyles,
                    color: gray700,
                    marginRight: "8px"
                }
            })}
        >
            <span>{t("Dashboard##imported activated devices##period")}</span>

            <Button
                variant={BUTTON_VARIANTS.IconRight}
                color={BUTTON_COLORS.White}
                size={BUTTON_SIZES.Tiny}
                icon={<ExpandMoreIcon />}
                onClick={handleOpenMenu}
            >
                {t(`Dashboard##imported activated devices##days##${period}`)}
            </Button>

            <Menu
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                anchorEl={anchorEl}
            >
                {periods.map(day => (
                    <ListChoice
                        key={day}
                        selected={day === period}
                        title={t(
                            `Dashboard##imported activated devices##days##${day}`
                        )}
                        onClick={() => {
                            onChange(day);
                            handleCloseMenu();
                        }}
                    />
                ))}
            </Menu>
        </div>
    );
};

export default PeriodSettings;
